<template>
  <component
    :is="iconComponent"
    role="img"
    class="inline-block fill-current"
    style="height: 1em; width: 1em;"
  />
</template>

<script>
const icons = {
  standard: require('./StandardIcon.vue'),
  overnight: require('./OvernightIcon.vue'),
  expeditedOne: require('./ExpeditedOneIcon.vue'),
  expeditedTwo: require('./ExpeditedTwoIcon.vue'),
}

export default {
  props: {
    name: {
      type: String,
      required: true,
      validator(value) {
        return Object.prototype.hasOwnProperty.call(icons, value)
      }
    }
  },

  computed: {
    iconComponent() {
      return icons[this.name]
    }
  }
}
</script>


// WEBPACK FOOTER //
// BaseIcon.vue?5cf54f58